import { useCallback, useState } from 'react';
import { Popup, Segment } from 'semantic-ui-react';
import getCarrierName from 'modules/get-carrier-name/get-carrier-name';
import classNames from 'classnames';
import './retryable-shipments-totals-bar.scss';

export default function RetryableShipmentsTotalsBar({
  filters,
  totals,
  canChooseAgency,
  onSelectAgency = () => {},
}) {
  const [currentOpenedWarehousePopup, setCurrentOpenedWarehousePopup] =
    useState();
  const getWarehouseTotal = useCallback((agencies = {}) => {
    return Object.entries(agencies).reduce(
      (sum, [agencyCode, { totals }]) => sum + totals,
      0,
    );
  }, []);

  const renderWarehouseTotals = useCallback(
    ([warehouse, { id: warehouseId, agencies = {} }]) => {
      const warehouseTotal = getWarehouseTotal(agencies);

      return (
        <Segment
          className={classNames('retryable-shipments-totals-bar__group', {
            'retryable-shipments-totals-bar__group--is-dimmed': !warehouseTotal,
          })}
          key={warehouse}
        >
          <Popup
            className="retryable-shipments-totals-bar__warehouse-agencies"
            trigger={
              <div
                className={classNames(
                  'retryable-shipments-totals-bar__warehouse',
                  {
                    'retryable-shipments-totals-bar__warehouse--selected':
                      filters?.warehouse_id === warehouseId,
                  },
                )}
              >
                {warehouse} ({warehouseTotal})
              </div>
            }
            open={
              currentOpenedWarehousePopup &&
              currentOpenedWarehousePopup === warehouseId
            }
            content={
              !!Object.keys(agencies)?.length &&
              Object.entries(agencies).map(
                ([agencyCode, { id: agencyId, totals }]) => (
                  <div
                    className={classNames(
                      'retryable-shipments-totals-bar__warehouse-agency',
                      {
                        'retryable-shipments-totals-bar__warehouse-agency--selected':
                          filters?.warehouse_id === warehouseId &&
                          filters?.agency_id === agencyId,
                      },
                    )}
                    key={`${warehouseId}-${agencyCode}`}
                    onClick={(event, data) => {
                      if (!!canChooseAgency) {
                        onSelectAgency(warehouseId, agencyId);
                        setCurrentOpenedWarehousePopup(null);
                      }
                    }}
                  >
                    {getCarrierName(agencyCode)} ({totals})
                  </div>
                ),
              )
            }
            on="click"
            position="bottom center"
            onOpen={() => setCurrentOpenedWarehousePopup(warehouseId)}
            onClose={() => setCurrentOpenedWarehousePopup(null)}
          />
        </Segment>
      );
    },
    [
      getWarehouseTotal,
      onSelectAgency,
      currentOpenedWarehousePopup,
      filters,
      canChooseAgency,
    ],
  );

  return (
    <Segment.Group horizontal>
      {Object.entries(totals).map(renderWarehouseTotals)}
    </Segment.Group>
  );
}
